import { useDispatch, useSelector } from 'react-redux';
import useWebShare from '../../../../../hooks/use-web-share';
import { useCallback } from 'react';
import { openShareBetModal as openShareBetModalActionCreator } from './sportsbook-share-bet-modal-duck';
import { AppDispatch } from '../../../../../store/types';
import { selectSportsbookShareBetModalEnabled } from '../../../../brand/ducks/selectors';

/**
 * Hook to be used by other features when intending to share bets as images.
 *
 * const { isShareBetModalEnabled, openShareBetModal } = useShareBetModal();
 * return (isShareBetModalEnabled && <Button onClick={() =>openShareBetModal(betId)}>Share bet</Button>);
 */
const useShareBetModal = () => {
	const dispatch: AppDispatch = useDispatch();

	const { isSupported } = useWebShare();
	const isShareBetModalEnabled = useSelector(selectSportsbookShareBetModalEnabled);

	const openShareBetModal = useCallback(
		(betId: number) => dispatch(openShareBetModalActionCreator(betId)),
		[dispatch]
	);

	return { isShareBetModalEnabled: isSupported && isShareBetModalEnabled, openShareBetModal };
};

export default useShareBetModal;
